import { CountDown } from 'vant';
export default {
  name: 'CountDown',
  props: {
    time: Number,
    state: String
  },
  components: {
    [CountDown.name]: CountDown
  }
};